import RevokePatientAccess from './RevokePatientAccess';

export default RevokePatientAccess;
